import { isLocalhost } from "../utils/isLocalhost";

/**
 * Campañas is a limited rollout. It is available everywhere on localhost (dev),
 * and in production only for the allowlisted companies below.
 */
export const CAMPAIGNS_ALLOWED_COMPANY_IDS = ["6963a4f8f55fc2f171d3ce99"];

export function canAccessCampaigns(companyId?: string | null): boolean {
  if (isLocalhost()) return true;
  return companyId != null && CAMPAIGNS_ALLOWED_COMPANY_IDS.includes(companyId);
}
